export enum ModalVariant {
  default = 'modal',
  dialog = 'dialog',
  withImage = 'modal with-image',
  mobileOverlay = 'modal mobile-overlay',
  guide = 'modal modal-guide with-image'
}
